/* Product card image swipe (touch screens) — keeps the two dots in sync
   with whichever image is showing. Used by snippets/orizza-discover-card.liquid
   and snippets/frost-discover-card.liquid.

   Every card that has an alternate image includes this file, so it guards
   against running twice. One capturing scroll listener on the document
   covers every card, including cards inserted later (e.g. Recently viewed). */
(function () {
  if (window.__dcSlidesInit) return;
  window.__dcSlidesInit = true;

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.hasAttribute || !track.hasAttribute('data-dc-slides')) return;
      var width = track.clientWidth;
      if (!width) return;
      var index = Math.round(track.scrollLeft / width);
      var media = track.parentNode;
      var dots = media ? media.querySelectorAll('[data-dc-dot]') : [];
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    },
    true
  );
})();
